export const CURRENT_SCREEN_NAME = {
  "menu_item_list": "menu_item_list",
  "menu_cart": "menu_cart",
  "menu_order_details": "menu_order_details",
  "menu_verify_otp": "menu_verify_otp",
  "menu_order_confirmation": "menu_order_confirmation",
};

const useAnalytics = () => {
  const fireEvent = (eventName, params = {}) => {
    if (window.gtag && typeof window.gtag === "function") {
      window.gtag("event", eventName, {
        ...params,
        current_page: window.location.href,
        timestamp: Date.now(),
      });
    }
  };

  const fireViewScreenEvent = (current_screen_name) => {
    const parameters = {
      current_screen_name,
    };
    fireEvent("view_screen", parameters);
  };

  const fireClickCategoryEvent = (current_screen_name, category_name) => {
    const parameters = {
      current_screen_name,
      category_name,
    };

    fireEvent("click_category", parameters);
  };

  const fireChangeQuantityEvent = (
    current_screen_name,
    product_name,
    quantity
  ) => {
    const parameters = {
      current_screen_name,
      product_name,
      quantity,
    };

    fireEvent("change_quantity", parameters);
  };

  const fireClickButtonEvent = (current_screen_name, button_name) => {
    const parameters = {
      current_screen_name,
      button_name,
    };

    fireEvent("click_button", parameters);
  };

  const fireConfirmOrderEvent = (
    store_mobile_number,
    store_name,
    full_name,
    address
  ) => {
    const parameters = {
      store_mobile_number,
      store_name,
      full_name,
      address,
    };

    fireEvent("confirm_order", parameters);
  };

  const firePlaceOrderEvent = (store_mobile_number, store_name, full_name) => {
    const parameters = {
      store_mobile_number,
      store_name,
      full_name,
    };

    fireEvent("place_order", parameters);
  };
  return {
    fireViewScreenEvent,
    fireClickCategoryEvent,
    fireChangeQuantityEvent,
    fireClickButtonEvent,
    fireConfirmOrderEvent,
    firePlaceOrderEvent,
  };
};

export default useAnalytics;
